import { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ASSOCIATE_PROMPT } from '../constants/PromptTypes';
import { ASSOCIATE_CONTACT_MARKER } from '../../performance-metrics/constants/performanceConstants';
import { startDuration } from '../../performance-metrics/gatherPerformanceMetrics';
import ContactPrompt from 'conversations-thread-view/contact-prompt/public/ContactPrompt';
import { getFirstName, getLastName } from 'conversations-inbox-lib/contacts/public/operators';
import { optimisticContactAssociation } from '../actions/optimisticContactAssociation';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { CRM_OBJECT } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isSuccess } from 'reference-resolvers-lite/Status';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getAssociatedVisitorToContact, getCreatedNewContact } from '../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociateContactToThreadPrompt = ({
  closePrompt,
  promptStatus,
  threadId
}) => {
  const inboxId = useSelector(getCurrentInboxId);
  const dispatch = useDispatch();
  const [optimisticContactId, setOptimisticContactId] = useState(undefined);
  const resolver = createStandardCachedResolver(CRM_OBJECT, CONTACT_TYPE_ID);
  const {
    status,
    reference
  } = useFetchResolver(resolver, optimisticContactId);
  useEffect(() => {
    if (isSuccess(status)) {
      const label = reference && reference.label;
      dispatch(optimisticContactAssociation({
        threadId,
        firstName: label
      }));
      setOptimisticContactId(undefined);
    }
  }, [status, dispatch, threadId, reference]);
  const handleAssociateContact = useCallback(({
    associatedObjectIds,
    createdObject,
    createdObjectId: __createdObjectId,
    addAnother: __addAnother,
    error: __error
  }) => {
    if (associatedObjectIds) {
      setOptimisticContactId(associatedObjectIds[0]);
      trackEvent(getAssociatedVisitorToContact());
    }
    if (createdObject) {
      const firstName = getFirstName(createdObject);
      const lastName = getLastName(createdObject);
      dispatch(optimisticContactAssociation({
        threadId,
        firstName,
        lastName
      }));
      trackEvent(getCreatedNewContact());
    }
    startDuration(ASSOCIATE_CONTACT_MARKER);
    closePrompt(ASSOCIATE_PROMPT);
  }, [closePrompt, dispatch, threadId]);
  if (!inboxId) return null;
  if (promptStatus[ASSOCIATE_PROMPT]) {
    return /*#__PURE__*/_jsx(ContactPrompt, {
      threadId: threadId,
      onClose: handleAssociateContact
    });
  }
  return null;
};
AssociateContactToThreadPrompt.displayName = 'AssociateContactToThreadPrompt';
export default AssociateContactToThreadPrompt;